import React from "react";

const shantanu_benake = () => {
  return (
    <div>
      <h1>Shantanu Benake</h1>

      <h3>
        <em>Computer Engineering, Batch of 27'</em>
        <br />
        <hr />
      </h3>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        It was based on CGPA. Those who had a CGPA of 7.5 or above were eligible
        for the aptitude test.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round mainly consisted of three sections. First one was
        coding section, second was English proficiency and third one was
        business section.
        <br />
        1] Coding Section :<br />
        This section included three coding questions. The first two were easy
        and could be completed quickly, within 8-10 minutes, even though 20
        minutes were allotted.
        <br />
        The third question was of medium to hard difficulty, with a 45-minutes
        time limit. It was comparatively lengthy and bit difficult to
        understand.
        <br />
        2] English Proficiency Section :<br />
        This section focused on grammar and comprehension. It included questions
        on identifying sentence errors, spell checks, and passage-based
        comprehension. A decent grasp of basic English grammar was sufficient to
        solve this section easily.
        <br />
        3] Business Section :<br />
        This part tested analytical and interpretation skills through graphs and
        market-related charts. The time provided was relatively short compared
        to the number of questions, so quick analysis and decision-making were
        essential. This section was bit easy for me.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After aptitude round, 25 students were shortlisted for interview
        process.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The list of shortlisted students was declared 3-4 days before the
        interviews. So it provided good amount of time to prepare.
        <br />
        In this period, I focused on topics like DBMS, OOPS, part of DSA and
        Java.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        1] The first round was Aptitude test.
        <br />
        2] Second round was technical interview round.
        <br />
        This was the first interview round. Some students had online interviews,
        while others had offline panels. I was part of the offline panel for all
        three interview rounds.
        <br />
        The discussion started with DSA questions, one easy and one that
        required more time. There was also another one scenario-based question.
        Later, questions from OOPS, multithreading, and a few simple ones from
        Operating Systems were asked. Additionally, some logical questions were
        included, which were easy.
        <br />
        3] Third one was Senior Manager interview round.
        <br />
        This round focused mainly on projects. Detailed questions about my
        projects were asked, so it’s important to have an in-depth understanding
        of your projects. Some logical questions which test your instantaneous
        thinking direction and extracurricular-related questions were also
        asked.
        <br />
        4] HR round :<br />
        This was a relatively easy round. The main goal was to check your values
        and mindset.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Mostly DSA, OOPS, DBMS, etc.{" "}
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <p>
        Honestly, I mostly relied on college lectures. Most of the necessary
        topics were already covered in the curriculum. Online resources helped
        me enhance my understanding and depth in the subject, but the foundation
        came from college teachings. If someone is not comfortable with the
        syllabus, they can definitely refer to online resources for better
        clarity.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Make sure you understand the question correctly. In my opinion,
        understanding the problem is harder than solving it. First, analyze the
        question carefully.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        In the Senior Manager Round, in-depth questions were asked about my
        projects, along with a few co-curricular activity-related questions.
        <br />
        The questions were easy, but it’s important to be honest and present
        yourself genuinely.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Believe in yourself and stay confident. If you don't know the answer to
        any of the question, then don’t try to fake your way through it as they
        will definitely notice that. Be honest and remain calm.
        <br />
        All the best!!
      </p>

      <hr />
    </div>
  );
};

export default shantanu_benake;
